import * as cnt from './constants';


const initialEditDialogState = {
  open: false,
  data: {},
};

export const editDialog = (state = initialEditDialogState, { type, payload, args }) => {
  switch (type) {
    case cnt.INITIATE_EDIT_WITH_TYPE:
      return {
        ...state,
        type: payload.type,
        policiesNotesPage: payload.policiesNotesPage,
        policyType: payload.policyType,
        data: {
          ...state.data,
          title: payload.title,
          ...payload.data,
        },
      };
    case cnt.POPULATE_EDIT_DIALOG_DATA:
      return {
        ...state,
        open: true,
        data: {
          ...state.data,
          ...payload,
        },
      };
    case `${cnt.SAVE_EDITS}_S3UPLOAD_STARTED`:
    case `${cnt.SAVE_EDITS}_STARTED`:
      return {
        ...state,
        saving: true,
      };
    case cnt.TEXT_FIELD_CHANGE:
      if (payload.forTermsAndNotes) {
        return {
          ...state,
          data: {
            ...state.data,
            value: payload.value,
          },
        };
      }
      return {
        ...state,
        data: {
          ...state.data,
          [payload.key]: payload.value,
        },
      };
    case cnt.ATTACH_INS_FILE:
      return {
        ...state,
        data: {
          ...state.data,
          insuranceFiles: payload,
        },
      };
    case cnt.REMOVE_INSURANCE_FILE:
      return {
        ...state,
        data: {
          ...state.data,
          insuranceFiles: [],
        },
      };
    case `${cnt.SAVE_EDITS}_SUCCESS`:
    case cnt.CANCEL_EDIT:
      return initialEditDialogState;
    default:
      return state;
  }
};


const initialSecondaryTemplateState = {
  // <id>: {}
  showAssociatedTemplates: false,
  currentId: '',
};

export function masterTemplate(state = initialSecondaryTemplateState, { type, payload, args }) {
  switch (type) {
    case `${cnt.GET_DOC}_STARTED`:
      return {
        ...state,
        currentId: args[0],
        [args[0]]: {
          ...state[args[0]],
          loading: true,
        },
      };
    case `${cnt.GET_DOC}_SUCCESS`:
      return {
        ...state,
        [state.currentId]: {
          ...state[state.currentId],
          loading: false,
          ...payload.data,
        },
      };
    case `${cnt.GET_DIFF_SUMMARY}_SUCCESS`:
      return {
        ...state,
        [state.currentId]: {
          ...state[state.currentId],
          ...payload,
        },
      };
    case `${cnt.DISCARD_DRAFT}_SUCCESS`:
      return {
        ...state,
        [args[0]]: {},
      };
    case `${cnt.GET_ASSOCIATED_TEMPLATES}_SUCCESS`:
      return {
        ...state,
        [state.currentId]: {
          ...state[state.currentId],
          templates: payload,
        },
      };
    case cnt.TOGGLE_ASSOCIATED_TEMPLATES:
      return {
        ...state,
        showAssociatedTemplates: !state.showAssociatedTemplates,
      };
    case cnt.apply.CLICK_OK_SUCCESS:
      return {
        ...state,
        showAssociatedTemplates: true,
      };
    default:
      return state;
  }
}


const initialAssoicateState = {
  type: 'policyNotes',
  knownMasterId: '',
  knownTemplateDraftId: '',
  allTemplatesDrafts: [],
  masterList: [],
  callingApi: false,
  successDialogOpen: false,
  sameAsCorporatePolicyNotes: [],
  honorPreloadContent: false,
};
export function applyMasterToTemplatesReducer(state = initialAssoicateState, { type, payload, args }) {
  switch (type) {
    case cnt.apply.INIT:
      return {
        ...state,
        knownMasterId: payload.knownMasterId,
        knownTemplateDraftId: payload.knownTemplateDraftId,
        type: payload.type,
      };
    case cnt.apply.SELECT_UNSELECT_TEMPLATE:
      return {
        ...state,
        allTemplatesDrafts: state.allTemplatesDrafts.map(obj => {
          if (obj._id === payload.id) return { ...obj, checked: !obj.checked };
          return obj;
        }),
      };
    case cnt.apply.CHECK_SAME_AS:
      return {
        ...state,
        sameAsCorporatePolicyNotes: payload,
      };
    case cnt.apply.CHECK_HONOR_PRELOAD:
      return {
        ...state,
        honorPreloadContent: payload,
      };
    case cnt.apply.CLICK_OK_SUCCESS:
      return {
        ...state,
        successDialogOpen: false,
      };
    case cnt.apply.SELECT_MASTER:
      if (state.type === 'policyNotes') {
        return {
          ...state,
          masterList: state.masterList.map(obj => {
            if (obj._id === payload.id) return { ...obj, checked: !obj.checked };
            return obj;
          }),
        };
      }
      // TODO: handle other master policy type
      return state;
    case `${cnt.apply.GET_TEMPLATES}_SUCCESS`:
      return {
        ...state,
        callingApi: false,
        allTemplatesDrafts: [
          ...payload.drafts,
          // only allow applying master to draft for now
          // this is just a HACK for now
          ...payload.templates
            .filter(obj => obj.templateHasDraft)
            .map(obj => ({ ...obj, originalContractId: obj._id, state: 'draft' })),
        ],
      };
    case `${cnt.apply.APPLY_TO_TEMPLATES}_SUCCESS`:
      return {
        ...state,
        callingApi: false,
        successDialogOpen: true,
      };
    case `${cnt.apply.GET_MASTERS}_SUCCESS`:
      return {
        ...state,
        callingApi: false,
        masterList: payload.filter(obj => obj.status === 'completed'),
      };
    case `${cnt.apply.GET_TEMPLATES}_STARTED`:
    case `${cnt.apply.APPLY_TO_TEMPLATES}_STARTED`:
    case `${cnt.apply.GET_MASTERS}_STARTED`:
      return {
        ...state,
        callingApi: true,
      };
    case `${cnt.apply.GET_TEMPLATES}_ERROR`:
    case `${cnt.apply.APPLY_TO_TEMPLATES}_ERROR`:
    case `${cnt.apply.GET_MASTERS}_ERROR`:
      return {
        ...state,
        callingApi: false,
      };
    case cnt.apply.CLEAR_STORE:
      return initialAssoicateState;
    default:
      return state;
  }
}

const finaliseDialogState = {
  open: false,
  buyerId: false,
  loadingBuyers: false,
  buyers: [],
};
export function finaliseDialog(state = finaliseDialogState, { type, payload, args }) {
  switch (type) {
    case cnt.OPEN_FINALISE_DIALOG:
      return {
        ...state,
        open: true,
      };
    case cnt.CLOSE_FINALISE_DIALOG:
      return finaliseDialogState;
    case `${cnt.SEND_UPDATES}_STARTED`:
    case `${cnt.FINALISE}_STARTED`:
      return {
        ...state,
        callingApi: true,
      };
    case `${cnt.SEND_UPDATES}_ERROR`:
    case `${cnt.FINALISE}_ERROR`:
      return {
        ...state,
        callingApi: false,
      };
    case `${cnt.FINALISE}_SUCCESS`:
      return {
        ...state,
        callingApi: false,
        finaliseSuccess: true,
      };
    case `${cnt.SEND_UPDATES}_SUCCESS`:
      return {
        ...state,
        callingApi: false,
        sendUpdatesSuccess: true,
      };
    case `${cnt.GET_AFFECTED_BUYERS}_STARTED`:
      return {
        ...state,
        loadingBuyers: true,
      };
    case `${cnt.GET_AFFECTED_BUYERS}_SUCCESS`:
      return {
        ...state,
        buyers: payload,
        loadingBuyers: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/contracting/master-template/__storeFiles__/reducer.js